import React, {Component} from 'react'
import { connect } from "react-redux";
import autobind from "autobind-decorator";
import If from "../../../../common/control/If";
import {jsonResponseHandler} from "../../../../../utils/FetchHelper";
import {changeCertReadyStatus, deleteCustomDomain, changeCustomDomainDnsFail} from '../../../../../actions/setting/blog'
import * as SaveStatus from "../../../../../constants/SaveStatus";

@connect(state => ({
    address: state.setting.blog.address
}), dispatch => ({
    handleDeleteCustomDomain(customDomain, useSecondaryDomain, certStatus, certExpireDate, dnsFailDetected) {
        dispatch(deleteCustomDomain(customDomain, useSecondaryDomain, certStatus, certExpireDate, dnsFailDetected))
    },
    handleUpdateCertStatus(certStatus, expireDate) {
        dispatch(changeCertReadyStatus(certStatus, expireDate))
    },
    handleUpdateDnsFailed(dnsFail) {
        dispatch(changeCustomDomainDnsFail(dnsFail))
    },
    dispatch
}))
class CustomDomainStatusForm extends Component {

    constructor(props, context) {
        super(props, context)

      this.state = Object.assign({
        dnsCheckStatus: SaveStatus.READY,
        certCheckStatus : SaveStatus.READY,
      })
    }

    @autobind
    checkDomainCertStatus() {
      const {dispatch , handleUpdateCertStatus} = this.props;
      this.setState({
        certCheckStatus: SaveStatus.DOING
      })

      fetch("/manage/setting/blog/checkCert.json", {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {

              console.log(data);
              this.setState({
                certCheckStatus: SaveStatus.READY
              })

              handleUpdateCertStatus(data.status, data.expireDate)
            })
            .catch(r => {

              this.setState({
                certCheckStatus: SaveStatus.READY
              })
            })
    }

    @autobind
    checkDomainDnsStatus() {
      const {dispatch , handleUpdateDnsFailed} = this.props;
      this.setState({
        dnsCheckStatus: SaveStatus.DOING
      })

      fetch("/manage/setting/blog/checkDns.json", {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {

              this.setState({
                dnsCheckStatus: SaveStatus.READY
              })

              handleUpdateDnsFailed(data.dnsFailDetected)

            })
            .catch(r => {

              this.setState({
                dnsCheckStatus: SaveStatus.READY
              })
            })

    }

    @autobind
    confirmOpenModifyForm() {

      const { openModifyForm } = this.props

      if(confirm("등록된 도메인을 변경하시면 연결을 위해 인증서 새로 발급되며 보안 접속하기까지 시간이 걸릴 수 있습니다. 도메인 주소를 수정하시겠습니까? ")) {
        openModifyForm()
      }
    }

    @autobind
    confirmDeleteCustomDomain() {

      const { dispatch, handleDeleteCustomDomain } = this.props

      if(confirm("등록된 도메인을 제거하면, 연결된 인증서도 삭제되며 재등록시 보안 접속하기까지 시간이 걸릴 수 있습니다. 도메인 주소를 해제하시겠습니까?")) {
        console.log('도메인 연결 해제!!!!')

        fetch("/manage/setting/blog/customDomain.json", {
            method: 'delete',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(data => {

          handleDeleteCustomDomain(null, false, null, null, false)

        })
        .catch(r => {

        })
      }

    }

    formatDate(date) {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    }

    render() {

      const { secondaryDomain, certStatus, certExpireDate, dnsFailDetected } = this.props.address
      const { dnsCheckStatus, certCheckStatus } = this.state

      const readyCustomCert = (certStatus === 'SUCCESS');
      const tistoryProtocol = (readyCustomCert) ? 'https' : 'http'

      let baseDate = new Date()
      let expireDate =new Date(certExpireDate);

      baseDate.setDate(baseDate.getDate() + 10);

      let closeToExpireDate = false

      if (baseDate > expireDate) {
        closeToExpireDate = true
      }

        return (
          <fieldset className="fld_domain fld_address1">
            <legend className="screen_out">개인 도메인</legend>
            <div className="item_set">
              <span className="txt_item">개인 도메인</span>
              <em className="txt_emph">{tistoryProtocol}://{secondaryDomain}</em>
              <label className="lab_btn">
                <span className="txt_btn">삭제</span>
                <button type="button" className="btn_g" value="삭제" onClick={this.confirmDeleteCustomDomain}/>
              </label>
              <label className="lab_btn">
                <span className="txt_btn">수정</span>
                <button type="button" className="btn_g" value="수정" onClick={this.confirmOpenModifyForm}/>
              </label>
            </div>
            <div className="item_set">
              <table className="tbl_item">
                <caption className="ir_caption">도메인 설정 정보</caption>
                <tbody>
                <tr>
                  <th scope="row">
                    <div className="inner_cell">DNS 설정 정보</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      <If condition={dnsFailDetected}>
                      도메인 설정 정보를 확인할 수 없습니다.
                        <button type="button" className="link_domain" onClick={this.checkDomainDnsStatus}>새로고침
                          <If condition={(dnsCheckStatus === SaveStatus.READY)} >
                            <span className="ico_blog ico_reload"/>
                          </If>
                          <If condition={(dnsCheckStatus === SaveStatus.DOING)} >
                            <span className="ico_blog ico_change">확인중</span>
                          </If>
                        </button>
                      </If>
                      <If condition={!dnsFailDetected}>
                      확인 완료
                      </If>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div className="inner_cell">보안 접속 인증서</div>
                  </th>
                  <td>
                    <div className="inner_cell">
                      <If condition={(certStatus === "NOT_FOUND")}>
                        인증서 발급 확인 불가
                      </If>
                      <If condition={(certStatus === 'SUCCESS')}>
                        발급 완료
                        <If condition={closeToExpireDate}>
                          <span className="txt_required">만료예정일 {this.formatDate(expireDate)}</span>
                        </If>
                      </If>
                      <If condition={(certStatus === 'FAILED')}>
                        발급 실패
                      </If>
                      <If condition={(certStatus === 'READY')}>
                        발급 대기 중
                        <button type="button" className="link_domain" onClick={this.checkDomainCertStatus}>새로고침
                          <If condition={(certCheckStatus === SaveStatus.READY)} >
                            <span className="ico_blog ico_reload"/>
                          </If>
                          <If condition={(certCheckStatus === SaveStatus.DOING)} >
                            <span className="ico_blog ico_change">확인중</span>
                          </If>
                        </button>
                      </If>
                      <If condition={(certStatus === 'DELETING')}>
                        삭제 진행중
                      </If>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <If condition={dnsFailDetected}>
              <p className="desc_domain">
                도메인 설정 정보에 문제를 발견했습니다.
              </p>
              <ol className="list_set list_set_type2">
                <li>
                  <span className="txt_num">1</span>
                  DNS 서비스에 가셔서 이상이 없는지 먼저 살펴 보세요.
                </li>
                <li>
                  <span className="txt_num">2</span>
                  블로그 관리 &gt; 개인 도메인 설정에 있는 “새로고침” 클릭하세요.
                </li>
              </ol>
            </If>
            <If condition={readyCustomCert}>
              <p className="desc_domain">
                연결한 개인 도메인은 보안 접속 중입니다.
              </p>
            </If>
            <If condition={(certStatus === 'READY')}>
              <p className="desc_domain">
                인증서 발급은 몇 시간에서 최대 7일 가량 소요됩니다.
                <br/>
                “발급 대기 중”이 7일이 넘어서도 지속될 경우 DNS 설정 정보를 확인해 주세요.
              </p>
            </If>
            <If condition={((certStatus === 'SUCCESS') && closeToExpireDate)}>
              <p className="desc_domain">
                인증서 자동갱신 이뤄지지 않았습니다.<br/>
                DNS 설정 정보를 재확인하시고, 지속될 경우 고객센터로 문의하세요.
              </p>
            </If>
          </fieldset>
        )
    }
}

export default CustomDomainStatusForm
